/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Rate_Per_HourInputs */

const en_rate_per_hour = /** @type {(inputs: Rate_Per_HourInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`₪${i?.amount}/hr`)
};

const he_rate_per_hour = /** @type {(inputs: Rate_Per_HourInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`₪${i?.amount}/שעה`)
};

/**
* | output |
* | --- |
* | "₪{amount}/hr" |
*
* @param {Rate_Per_HourInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const rate_per_hour = /** @type {((inputs: Rate_Per_HourInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rate_Per_HourInputs, { locale?: "en" | "he" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rate_per_hour(inputs)
	return he_rate_per_hour(inputs)
});